import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectForecaster = (state: RootState) => state.forecaster;

export const selectForecastTablePagination = createSelector([selectForecaster], ({ filters }) => ({
  page: filters.page - 1,
  pageSize: filters.limit,
}));

export const selectForecastTableRowCount = createSelector([selectForecaster], ({ total }) => total);
